/**
 * Custom Label Minimum Quantity
 * Enforces qty >= 25 when the IO "Want to Add a Custom Label?" field = YES.
 */

(function () {
  const MIN_QTY = 25;

  function isCustomLabelYes() {
    const ioContainer = document.getElementById('infiniteoptions-container');
    const searchRoot = ioContainer || document;

    return !!searchRoot.querySelector('input[name="properties[rad_custom_label]"][value="YES"]:checked');
  }

  function init() {
    document.querySelectorAll('.custom-label-min-qty-marker').forEach((marker) => {
      const form = marker.closest('form[data-type="add-to-cart-form"]');
      if (!form) {
        console.warn('[MinQty] marker found but no add-to-cart form ancestor');
        return;
      }

      console.log('[MinQty] initialized. metafield value:', marker.dataset.metafieldValue);

      const minQty = parseInt(marker.dataset.customLabelMinQty, 10) || MIN_QTY;

      const errorEl = document.createElement('p');
      errorEl.className = 'custom-label-min-qty-error';
      errorEl.hidden = true;
      marker.after(errorEl);

      form.addEventListener('click', (e) => {
        const btn = e.target.closest('[name="add"], .add-to-cart-button');
        if (!btn) return;

        const yesSelected = isCustomLabelYes();
        const qty = parseInt(form.querySelector('input[name="quantity"]')?.value, 10) || 1;

        console.log('[MinQty] click — yesSelected:', yesSelected, '| qty:', qty);

        if (!yesSelected) {
          errorEl.hidden = true;
          return;
        }

        if (qty < minQty) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          errorEl.textContent = `A minimum quantity of ${minQty} is required when adding a custom label. Please update the quantity above.`;
          errorEl.hidden = false;
          form.querySelector('.quantity-selector')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          errorEl.hidden = true;
        }
      }, true); // capture phase

      form.querySelector('input[name="quantity"]')?.addEventListener('change', () => {
        errorEl.hidden = true;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
